import { CampaignDefaultThreadStarterContentType, CampaignStateFilter } from '@ms/yammer-graphql';
import { CampaignsWidgetEntrypointEnum } from '@ms/yammer-telemetry';

import { Entity, EntityMap } from '../types';

export { CampaignStateFilter, CampaignsWidgetEntrypointEnum };

export enum CampaignFollowedEntrypointEnum {
  CampaignPage = 0,
  UserProfileSideBar = 1,
  HomeFeedSideBar = 2,
  StorylineSideBar = 3,
  LeadersSideBar = 4,
  CampaignsHubPage = 5,
  GroupSideBar = 6,
  RecommendationReasonLabel = 7,
}

export enum CampaignUnfollowedEntrypointEnum {
  CampaignPage = 0,
  UserProfileSideBar = 1,
  HomeFeedSideBar = 2,
  StorylineSideBar = 3,
  LeadersSideBar = 4,
  CampaignsHubPage = 5,
  GroupSideBar = 6,
  RecommendationReasonLabel = 7,
}

export enum CampaignVisitedEntrypointEnum {
  Hashtag = 0,
  CampaignManagementPage = 1,
  UserProfileSideBar = 2,
  HomeFeedSideBar = 3,
  StorylineSideBar = 4,
  LeadersSideBar = 5,
  Search = 6,
  AnalyticsFunctionBar = 7,
  GroupSideBar = 8,
  CampaignsHubPage = 9,
  UserProfileCampaignBanner = 10,
}

export enum CampaignSashAddedEntrypointEnum {
  CampaignPage = 0,
  CampaignsHubPageModal = 1,
}

export enum CampaignSashRemovedEntrypointEnum {
  CampaignPage = 0,
}

export enum CampaignSashModalDisplayedEntrypointEnum {
  CampaignPage = 0,
  CampaignsHubPage = 1,
}

export enum CreateCampaignClickedEntrypointEnum {
  CampaignManagementPage = 0,
  GroupCampaignManagementPage = 1,
  CampaignWidget = 2,
  UniversalCreateButton = 3,
}

export enum ManageCampaignsClickedEntrypointEnum {
  Settings = 0,
  VivaAdmin = 1,
  AnalyticsFunctionBar = 2,
}

export interface Campaign extends Entity {
  readonly id: string;
  readonly databaseId: string;
  readonly createdBy: string;
  readonly permalink: string;
  readonly teamsAppLink: string;
  readonly sashImageUrl: string | null;
  readonly threadStarterDefaultContentType: CampaignDefaultThreadStarterContentType;
  readonly viewerCanStartThread: boolean;
  readonly viewerCanEditCampaign: boolean;
  readonly viewerCanManageOrganizers: boolean;
  readonly viewerCanDeleteCampaign: boolean;
  readonly totalThreadStarters?: number;
}

export interface MessageCampaignReference extends Entity {
  readonly id: Campaign['id'];
  readonly schema: 'campaignReferences';
}

export type Campaigns = EntityMap<Campaign>;
